import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {BehaviorSubject} from 'rxjs';
import {filter, switchMap, takeUntil} from 'rxjs/operators';

import {Destroyable} from '../../destroyable.component';
import {RolesService} from '../../shared/authentication/roles/roles.service';
import {OngoingPayrollsService} from '../ongoing/ongoing-payrolls.service';
import {PayTypeSelector, PayTypeWithCliRegIds} from '../payrolls.model';

@Injectable({
  providedIn: 'root'
})
export class PayrollUtilsService extends Destroyable {

  // Subscribe to this in order to get distinct and sorted pay types both on init and when lang changes
  public payTypesSorted$: BehaviorSubject<PayTypeWithCliRegIds[]> = new BehaviorSubject<PayTypeWithCliRegIds[]>(null);

  constructor(private ongoingPayrollsService: OngoingPayrollsService,
              private rolesService: RolesService,
              private translate: TranslateService
  ) {
    super();

    if (this.rolesService.hasRole('PAYROLL_READ', 'PAYROLL_WRITE', 'POSTPAY_PAYMENTS')) {
      this.ongoingPayrollsService.fetchDistinctPayTypes()
        .pipe(
          takeUntil(this.componentDestroyed$),
          filter(response => !!response.length)
        )
        .subscribe((payTypes: PayTypeWithCliRegIds[]) => {
          this.payTypesSorted$.next(payTypes);
        });

      this.translate.onLangChange
        .asObservable()
        .pipe(
          takeUntil(this.componentDestroyed$),
          filter(() => {
            const currentPayTypes: PayTypeWithCliRegIds[] = this.payTypesSorted$.getValue();
            return (currentPayTypes && !!currentPayTypes.length);
          }),
          switchMap(() => {
            const currentPayTypes: PayTypeWithCliRegIds[] = this.payTypesSorted$.getValue();
            return this.ongoingPayrollsService.updatePayTypesOnLangChange(currentPayTypes);
          })
        )
        .subscribe((payTypes: PayTypeWithCliRegIds[]) => {
          this.payTypesSorted$.next(payTypes);
        });
    }
  }

  public isPayType(payType: PayTypeSelector): payType is PayTypeWithCliRegIds {
    return (<PayTypeWithCliRegIds>payType).transId !== undefined;
  }

}
